(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputDeleteController',GrievanceDashboardOutputDeleteController);

    GrievanceDashboardOutputDeleteController.$inject = ['$uibModalInstance', 'entity', 'GrievanceDashboardOutput'];

    function GrievanceDashboardOutputDeleteController($uibModalInstance, entity, GrievanceDashboardOutput) {
        var vm = this;

        vm.grievanceDashboardOutput = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GrievanceDashboardOutput.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
